/** Replaces the old coupon-status (draft/active) filter, which no longer has
 *  a matching concept once every non-invalid coupon is just "assigned"
 *  (backend Task 1). Filters the coupon table by the CREATOR's content-live
 *  status (roster_posts "live"), already exposed per-coupon as
 *  `creator_live`. */
export type CouponLiveFilter = 'all' | 'live' | 'not_live';

/** Filter tabs for the coupon tables, shared by the authed Coupons tab and
 *  the public share view so the two can't label the same filter differently.
 *
 *  The labels name CONTENT deliberately. The filter reads `creator_live` —
 *  the creator's own content — while the header right above it counts CODES,
 *  so a bare "Live"/"Not live" made one page use "live" for two different
 *  things: on prod "Live" showed 0 rows while "Not live" showed every active
 *  code, which reads as a bug. */
export const COUPON_LIVE_FILTER_TABS: ReadonlyArray<{ key: CouponLiveFilter; label: string }> = [
  { key: 'all', label: 'All' },
  { key: 'live', label: 'Content live' },
  { key: 'not_live', label: 'Content not live' },
];
